import React from 'react'

import { Box } from '../Box'
import { Button } from '../Button'
import { Text } from '../Text'

type Props = {
  text: string
  buttonText?: string
  onPress?: () => void
}

export const Banner = ({ text, buttonText, onPress }: Props) => {
  return (
    <Box backgroundColor='v2primary' padding={{ top: 'sm', bottom: 'sm' }}>
      <Box
        margin={{ left: 'md', right: 'md' }}
        flexDirection='row'
        justifyContent='space-between'
        align='center'
      >
        <Text bold fontSize='sm' color='white'>
          {text}
        </Text>
        <Button
          title={buttonText}
          size='xxs'
          type='black'
          padding={{ vertical: 'xs', horizontal: 'md' }}
          fullWidth
          borderRadius='xxs'
          fontWeight='normal'
          titleColor='white'
          testID='FinishPendingMembershipButton'
          onPress={onPress}
        />
      </Box>
    </Box>
  )
}
